import { Item, ItemColected, OwnerItem } from '@/types/item';
import { t } from 'i18next';
import {
    LeadingActions,
    SwipeableList,
    SwipeableListItem,
    SwipeAction,
    TrailingActions,
    Type
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import fillterIcon from '@/assets/images/pngs/Funnel.png';
import bgItem from '@/assets/images/pngs/item-location.png';
import { cn } from '@/utils/utils';
import { ITEMS_CONST } from '@/configs/constants';
import CheckboxComponent from '../common/CheckBox';
import { useEffect, useRef } from 'react';
import { useStore } from '@/hooks/useStore';

interface SwipeListProps {
    items: OwnerItem[],
    iconRight?: string,
    listClassname?: string,
    blockSwipe?: boolean,
    rightFunction?: Function,
    onClickItem?: Function,
    showStatusItem?: boolean,
    showFilter?: boolean,
    filterShowFunc?: Function,
    showCheckBox?: boolean,
    onChangeCheck?: Function,
    onEndReached?: () => Promise<void>,
    isLoading: boolean
}
const leadingActions = () => (
    <LeadingActions>
        <SwipeAction onClick={() => console.info('swipe action triggered')}>
            Action name
        </SwipeAction>
    </LeadingActions>
);

const deleteActions = (icon: string | undefined, rightFunction: Function, id: string) => (
    <TrailingActions>
        <SwipeAction
            onClick={() => rightFunction(id)}
        >
            <div className='bg-red-500 w-[62px] flex justify-center items-center content-center'>
                <img src={icon} alt={icon} className='w-[18px] h-[18px]' />
            </div>
        </SwipeAction>
    </TrailingActions>

);

const getStatus = (activity: number) => {
    switch (activity) {
        case ITEMS_CONST.ACTIVITY.PUBLISHED__USED:
            return t('itemActivity.used');
        case ITEMS_CONST.ACTIVITY.PRIVATE__WITHDRAWAL:
            return t('itemActivity.withdrawal');
        case ITEMS_CONST.ACTIVITY.PUBLISHED__GET_IT:
            return t('itemActivity.getIt');
        case ITEMS_CONST.ACTIVITY.PUBLISHED__RESTORE:
            return t('itemActivity.restore');
        case ITEMS_CONST.ACTIVITY.PRIVATE__REPORT:
            return t('itemActivity.report');
        case ITEMS_CONST.ACTIVITY.PUBLISHED__ON_MAP:
            return t('itemActivity.onMap');
        case ITEMS_CONST.ACTIVITY.PRIVATE__EXPIRED:
            return t('itemActivity.expired');
        default:
            return '';
    }
};
const getBgColorStatus = (activity: number) => {
    switch (activity) {
        case ITEMS_CONST.ACTIVITY.PUBLISHED__USED:
            return 'bg-gradient-to-r from-[#35EA8B] to-[#43F4BF]';
        case ITEMS_CONST.ACTIVITY.PRIVATE__WITHDRAWAL:
            return 'bg-gradient-to-r from-[#EA355D] to-[#F44343]';
        case ITEMS_CONST.ACTIVITY.PUBLISHED__GET_IT:
            return 'bg-gradient-to-r from-[#356FEA] to-[#F443AE]';
        case ITEMS_CONST.ACTIVITY.PUBLISHED__RESTORE:
            return 'bg-gradient-to-r from-[#FFAD00] to-[#E5D541]';
        case ITEMS_CONST.ACTIVITY.PRIVATE__REPORT:
            return 'bg-gradient-to-r from-[#FF200E] to-[#F44343]';
        case ITEMS_CONST.ACTIVITY.PUBLISHED__ON_MAP:
            return 'bg-gradient-to-r from-[#35EA8B] to-[#43F4BF]';
        case ITEMS_CONST.ACTIVITY.PRIVATE__EXPIRED:
            return 'bg-gradient-to-r from-[#FF200E] to-[#F44343]';
        default:
            return '';
    }
};

const getStatusPublict = (status: number) => {
    switch (status) {
        case ITEMS_CONST.STATUS.PRIVATE:
            return t('itemStatus.private');
        case ITEMS_CONST.STATUS.PUBLISHED:
            return t('itemStatus.published');
        case ITEMS_CONST.STATUS.UN_PUBLISHED:
            return t('itemStatus.unPublict');
        default:
            return '';
    }
};

const getColorStatusPublict = (status: number) => {
    switch (status) {
        case ITEMS_CONST.STATUS.PRIVATE:
            return 'text-[#A90E0E]';
        case ITEMS_CONST.STATUS.PUBLISHED:
            return 'text-[#34A853]';
        case ITEMS_CONST.STATUS.UN_PUBLISHED:
            return 'text-[#585858]';
        default:
            return '';
    }
};

export const SwipeList = ({ items = [], iconRight = undefined,
    listClassname, blockSwipe = false,
    rightFunction = () => { },
    onClickItem = () => { },
    showStatusItem = false,
    filterShowFunc = () => { },
    showFilter = true,
    showCheckBox = false,
    onChangeCheck = () => { },
    onEndReached, isLoading }: SwipeListProps) => {
    const sentinelRef = useRef<HTMLDivElement>(null);
    const isFetching = useRef(false);
    useEffect(() => {
        if (!onEndReached || !sentinelRef.current || isLoading) return;

        const observer = new IntersectionObserver(
            async ([entry]) => {
                if (entry.isIntersecting && !isFetching.current) {
                    isFetching.current = true; // Đánh dấu đang tải dữ liệu
                    await onEndReached(); // Gọi API
                    setTimeout(() => (isFetching.current = false), 1000); // Đợi 1 giây trước khi cho phép gọi tiếp
                }
            },
            { rootMargin: '100px' }
        );

        observer.observe(sentinelRef.current);

        return () => observer.disconnect();
    }, [onEndReached]);

    const {
        itemsStore: { total }
    } = useStore();
    return (
        <div className=''>
            {showFilter && (
                <div className='flex w-full justify-between items-center mb-3'>
                    <p className='text-[13px] text-gray'>
                        <span>{t('text.total')}</span>
                        <span className='text-black'>{t('text.countItems', { total: total })}</span>
                    </p>
                    <button onClick={() => filterShowFunc()} className='w-7 h-7 bg-white flex justify-center items-center rounded-full'>
                        <img src={fillterIcon} alt={fillterIcon} className='w-4 h-4' />
                    </button>
                </div>
            )}
            <SwipeableList
                className={cn('overflow-y-scroll scrollbar-hide mb-3 space-y-3 ', listClassname)}
                type={Type.IOS}
            >
                {items && items.map(e => (
                    <SwipeableListItem
                        key={e.id}
                        // leadingActions={leadingActions()}
                        trailingActions={deleteActions(iconRight, rightFunction, e.id.toString())}
                        blockSwipe={blockSwipe}
                        onClick={() => {
                            if (e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && blockSwipe) {
                                return;
                            } else {
                                onClickItem(e.id, e.item);
                            }
                        }}
                    >
                        {/* <ItemCard item={e} showStatus={showStatusItem} blockSwipe={blockSwipe} /> */}
                        <div className={`flex items-center bg-white shadow-md w-full h-[124px] rounded-1 no-drag relativep ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && blockSwipe && 'filter grayscale brightness-100'}`}>
                            <img src={bgItem} alt={bgItem} className='w-full h-full rounded-[4px]' />
                            <div className='w-[100px] h-[100px] absolute top-[12px] left-[12px] rounded-[4px]'>
                                <img src={e.file?.path} alt={e.file?.path} className='w-full h-full object-cover rounded-[4px]' />
                                {e?.itemType === ITEMS_CONST.ITEM_TYPE.COUPON && (
                                    <div className='absolute top-0 right-0 bg-gradient-to-r from-[#EA4335] to-[#F47843] text-white text-xs px-[12px] py-[2px] rounded-bl-sm rounded-tr-sm'>
                                        {t('text.coupon')}
                                    </div>
                                )}
                            </div>
                            <div className='absolute left-[124px] right-3 '>
                                <p className={`font-bold text-[15px] line-clamp-1 ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && blockSwipe && 'text-textInactive'}`}>
                                    {e.item}
                                </p>
                                {!blockSwipe && (
                                    <p className={cn('text-[13px] font-semibold', `${getColorStatusPublict(e.status)}`)}>{getStatusPublict(e.status)}</p>
                                )}
                                <p className={`text-gray text-[13px] line-clamp-2 ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && blockSwipe && 'text-textInactive'}`}>{e.description}</p>
                                {(e.remainingTime && blockSwipe) && <p className='text-txtReport text-[13px] mt-[6px]'>{t('text.expireAfter', { day: e.remainingTime })}</p>}

                            </div>
                            {showStatusItem && (
                                <div className={`absolute top-0 right-0 text-white text-xs px-3 py-[2px] rounded-bl-sm rounded-tr-sm ${getBgColorStatus(e.activity)}`}>
                                    {getStatus(e.activity)}
                                </div>
                            )}

                        </div>
                        {showCheckBox && (
                            <div
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onChangeCheck(e.id);
                                }}
                                className='w-10 h-10 absolute top-[14px] right-[14px] flex justify-end items-start'
                            >
                                <CheckboxComponent checked={e.isSelected} />
                            </div>
                        )}
                    </SwipeableListItem>
                ))}

                <div ref={sentinelRef} className='h-4'></div>
            </SwipeableList>
        </div>

    );
};
